import img from '../assets/phoenix-logo.png';
import FC1 from '../assets/C3.png';
import FC2 from '../assets/C4.jpg';
import BAD from '../assets/BADM.png';
import LC1 from '../assets/LC3.png';
import LC2 from '../assets/LC4.png';

export const IMAGES = {
  img,
  FC1,
  FC2,
  BAD,
  LC1,
  LC2,
};

export const HolidayDates  = [
  '2026-10-25',
  '2026-11-08',
  '2026-11-24',
  '2026-12-23',
  '2026-12-25',
  '2027-01-15',
  '2027-01-22',
  '2027-02-04',
  '2027-02-20',
  '2027-03-06',
  '2027-03-10',
  '2027-03-22',
  '2027-03-26',
  '2027-04-13',
  '2027-04-14',
  '2027-04-20',
  '2027-05-01',
  '2027-05-17',
  '2027-05-19',
  '2027-05-20',
  '2027-06-18',
  '2027-07-18',
  '2027-08-15',
  '2027-08-16',
  '2027-09-15',
  '2027-10-15',
  '2027-10-28',
  '2027-11-13',
  '2027-12-13',
  '2027-12-25',
];